import React from "react"
import Layout from "./layouts/Layout"
import {BrowserRouter} from "react-router-dom"
import Loader from "./components/loader/Loader"
import {withAuthenticationRequired} from "@auth0/auth0-react"
import AuthProvider from "./features/auth/AuthProvider"
import PermissionRoutes from "./features/permission/PermissionRoutes"

function App() {
    return (
        <AuthProvider>
            {/* Suspense живёт внутри PermissionRoutes, чтобы загрузка чанка страницы
                не размонтировала Layout и не давала лишний полноэкранный лоадер */}
            <BrowserRouter>
                <Layout>
                    <PermissionRoutes />
                </Layout>
            </BrowserRouter>
        </AuthProvider>
    )
}

export default withAuthenticationRequired(App, {onRedirecting: () => <Loader>Загрузка...</Loader>})
